import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getTransaction } from '../api';

export const useTransaction = (id: string) => {
  const [transactionDetails, setTransactionDetails] = useState<any>(null);
  const { data, isLoading } = useQuery(['transaction', id], () => getTransaction(id));

  useEffect(() => {
    if (data) {
      setTransactionDetails(data.data.data);
    }
  }, [data]);

  return {
    transactionDetails,
    isLoading,
  };
};
